const roles = {
  ADMIN: 'ADMIN',
}

export default roles
